const list = {
    path: 'undividedAccount',
    component: resolve => require(['@/pages/admin/aftersales/undividedAccount'], resolve)
}

export default list
